import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { AlertService } from 'src/app/core/alert.service';
import { OptionsSource } from 'src/app/core/core.models';
import { LoadingService } from 'src/app/core/loading.service';
import { LookupSource, LS } from 'src/app/shared/base/base.models';
import { CostPolicy } from '../../cost-policies/cost-policies.models';
import { CostPoliciesService } from '../../cost-policies/cost-policies.service';
import { PointOfSale } from '../../points-of-sale/points-of-sale.models';
import { CustomerOrderCost } from '../customer-orders.models';

@Component({
  selector: 'app-customer-order-costs',
  templateUrl: './customer-order-costs.component.html',
  styleUrls: ['./customer-order-costs.component.scss']
})
export class CustomerOrderCostsComponent {
  @Output() forcePendingChanges = new EventEmitter();
  @ViewChild('grid') grid: DxDataGridComponent;
  @Input('costs') costs: CustomerOrderCost[];
  @Input('pointOfSale') pointOfSale: PointOfSale;

  public costsFormCaption: string;
  public costsFormSubmitCaption: string;
  public costsFormSubmitIcon: string;
  public isCostsFormVisible: boolean = false;
  public selectedCost: CustomerOrderCost;
  public costPolicies: OptionsSource;

  constructor(private costPoliciesService: CostPoliciesService, private translateService: TranslateService, private alertService: AlertService, public loadingService: LoadingService) { }
  
  ngOnChanges(changes: SimpleChanges) {
    // TODO getlookup u costpolici service
    if(changes.pointOfSale.currentValue)
      // this.costPolicies = this.costPoliciesService.getCostPoliciesOptionsByPosId(this.pointOfSale.id);

      this.costPolicies = this.costPoliciesService.getLookup(LS.get('DvFO'), LS.get('D'), LookupSource.COST_POLICY, `point_of_sale='${this.pointOfSale.id}'`)
  }

  public onToolbarPreparingCosts(event: any): void { // za costs
    event.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'plus',
        hint: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
        onClick: this.openAddCostsForm.bind(this)
      },
      locateInMenu: 'auto'
    });
  }

  public onEditorPreparingCosts($event: any): void {
    $event.editorOptions.onValueChanged = (event: any) => {
      let row = $event.row.rowIndex;
      let cost: CustomerOrderCost = $event.row.data;
      if (cost != null) {
        if ($event.dataField == 'value') {
          $event.component.cellValue(row, 'value', event.value)
          this.forcePendingChanges.emit();
          this.grid.instance.saveEditData();
        }
      }
    }
  }

  public openAddCostsForm() {
    this.costsFormCaption = 'SHARED.ADD_ITEM';
    this.costsFormSubmitCaption = 'DEV-EXTREME.dxDataGrid-editingAddRow';
    this.costsFormSubmitIcon = 'add';
    this.isCostsFormVisible = true;
  }

  public closeCostsForm() {
    this.selectedCost = null;
    this.isCostsFormVisible = false;
  }

  public saveCost() {
    let costExists: boolean = false;
    if(this.costs)
      for (let cop of this.costs) {
        let copCost = <CostPolicy>cop.costPolicy;
        let selCost = <CostPolicy>this.selectedCost;
        if (copCost.id == selCost.id) {
          costExists = true;
          break;
        }
      }

    if (costExists) {
      this.alertService.error('CUSTOMER_ORDERS.COST_UNIQUE');
      return;
    }

    if(this.costs)
      this.costs.push({
        value: this.selectedCost.value,
        costPolicy: <CostPolicy>this.selectedCost
      });
    else
      this.costs = [ { 
        value: this.selectedCost.value,
        costPolicy: <CostPolicy>this.selectedCost 
      } ]
    
    
    this.closeCostsForm();
    this.forcePendingChanges.emit();
    this.grid.instance.saveEditData();
  }
}
